export default {
	available: {
		dates: '{direction} {from} {separator} {until}',
		from: 'From',
		immediately: 'Immediately',
		label: 'Available',
		until: 'Until',
	},
	delivery: {
		cost: 'est. £{price}',
		ferryWarning: 'Journey involves a ferry crossing.',
		label: 'Motorway delivery to {postCode}',
		notApplicable: 'N/A',
		plusVat: ' +VAT',
	},
	tooltipContent: {
		driven:
			'Estimated price based on driven transport{appendWithDrivingDistance}. Price may vary if vehicle needs to be transported.',
		drivingDistance: ' and accurate mileage of {drivingDistance} miles',
		ferryWarning:
			'Please contact our dedicated Transport team at the point of booking delivery for a bespoke delivery quotation.',
		heavyTransported: 'Estimated price based on heavy transported option{appendWithDrivingDistance}.',
		mileage: 'Straight line distance from dealership to vehicle. Exact location provided to the winning bidder.',
		transported:
			'Estimated price based on transported option{appendWithDrivingDistance}. Price may vary if vehicle needs to be heavy transported.',
	},
};
